export default __webpack_public_path__ + "static/media/qblbasP24.1b722dd5.jpg";